export default "__VITE_ASSET__0ZA7sDfY__"